import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMarkup"><Path d="M15.2051 17.1104L13.7148 19.5H21.0098V21H3V17.7705L6.35547 11.9736L15.2051 17.1104ZM21.8594 8.43555L17.0889 16.4688L5.96387 10.0117L10.7344 1.97852L21.8594 8.43555Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarkup;
